'use client';

import { type FC, useEffect, useState } from 'react';
import { DocumentViewerProps } from './DocumentViewer.types';
import { convertHeicToJPEG } from '@/_utils/files';

export const DocumentViewer: FC<DocumentViewerProps> = ({ url }) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setHasError(false);

        const parsedUrl = new URL(url);
        const isHeic = parsedUrl.pathname.toLowerCase().endsWith('.heic');

        if (isHeic) {
          const converted = await convertHeicToJPEG(url);
          if (!cancelled) setImageUrl(converted);
        } else {
          if (!cancelled) setImageUrl(url);
        }
      } catch (err) {
        console.error('DocumentViewer: failed to load image', err);
        if (!cancelled) setHasError(true);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [url]);

  if (hasError) {
    return <div>Error rendering file</div>;
  }

  if (!imageUrl) {
    return <div>Loading...</div>;
  }

  return <img src={imageUrl} alt="Preview Image" />;
};
